import { ParaSwapVersionUnion } from './types';

export {
  SwapSide,
  ContractMethod,
  ContractMethodV5,
  ContractMethodV6,
} from '@paraswap/core';

export const API_URL = 'https://api.paraswap.io';
export const DEFAULT_VERSION = '6.2' satisfies ParaSwapVersionUnion;
